import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MeasureFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 4C8.98478 4 8.96956 3.99996 8.95435 3.99991C8.92396 3.99983 8.8936 3.99974 8.86328 4H9Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 13H15.7229H21H22C22.5523 13 23 12.5523 23 12V5C23 4.4477 22.5523 4 22 4H21.8633H18.75H17.25H14.75H13.25H10.75H9.25H9H8.86328C7.54137 4 6.30505 4.17449 5.25033 4.47773C4.65973 4.63943 4.11192 4.8394 3.62032 5.0735C2.2664 5.7182 1 6.8043 1 8.3333V15.5C1 15.8705 1.48897 15.9153 1.72292 15.628C2.75246 14.3638 4.79264 13.4142 7.2619 13.1065C7.81207 13.0372 8.3956 13 9 13ZM18.75 5.49998H17.25V8.5C17.25 8.9142 17.5858 9.25 18 9.25C18.4142 9.25 18.75 8.9142 18.75 8.5V5.49998ZM14.75 5.49998H13.25V8.5C13.25 8.9142 13.5858 9.25 14 9.25C14.4142 9.25 14.75 8.9142 14.75 8.5V5.49998ZM10.75 5.49998H9.25V8.5C9.25 8.9142 9.58579 9.25 10 9.25C10.4142 9.25 10.75 8.9142 10.75 8.5V5.49998ZM6.75 5.67393C6.19906 5.76825 5.6949 5.89705 5.25 6.05059V9C5.25 9.4142 5.58579 9.75 6 9.75C6.41421 9.75 6.75 9.4142 6.75 9V5.67393Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.0557 18.4959C15.8356 17.9955 16.4993 17.3354 16.8106 16.5222C16.9322 16.2047 17 15.8638 17 15.5C17 15.3888 16.9937 15.2797 16.9814 15.1728C16.9338 14.7583 16.5424 14.5 16.1251 14.5H14.963H14.4999H11.3562C11.0306 14.5 10.9618 15.1762 10.9957 15.5C10.9957 16.0178 10.2085 16.444 9.19988 16.4951L8.99579 16.5C7.89129 16.5 6.99585 16.0523 6.99585 15.5C6.99587 15.0822 6.88744 14.7416 6.47475 14.8068C5.55134 14.9527 4.95399 15.1323 4.07812 15.625C3.73452 15.8183 3.45978 16.0139 3.24224 16.2055C2.68035 16.7004 2.5 17.1684 2.5 17.5C2.5 17.764 2.61426 18.1143 2.94423 18.4959C3.1568 18.6323 3.378 18.7568 3.60304 18.8693C5.03591 19.5857 6.94542 20 9 20C11.0546 20 12.9641 19.5857 14.397 18.8693C14.622 18.7568 14.8432 18.6323 15.0557 18.4959Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MeasureFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MeasureFilledIcon;
